var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "450" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Generator Config"),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              (_vm.view_flags & 0x01) !== 0
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8", md: "8" } },
                        [
                          _c("r-item-dropdown", {
                            attrs: {
                              model: _vm.model.item,
                              disabled: !_vm.model.empty() && !_vm.model.item,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "item", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4", sm: "4" } },
                        [
                          _vm.model.item && !_vm.model.item.empty()
                            ? _c("r-item-state-dropdown", {
                                attrs: { model: _vm.model.item.state },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model.item,
                                      "state",
                                      $event
                                    )
                                  },
                                },
                              })
                            : _c("r-item-state-dropdown", {
                                attrs: { disabled: true },
                              }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8", md: "8" } },
                        [
                          _c("r-item-cluster-dropdown", {
                            attrs: {
                              model: _vm.model.itemCluster,
                              clearable: true,
                              disabled:
                                !_vm.model.empty() && !_vm.model.itemCluster,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "itemCluster",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.view_flags & 0x02) !== 0
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8", md: "8" } },
                        [
                          _c("r-card-dropdown", {
                            attrs: {
                              model: _vm.model.card,
                              clearable: true,
                              disabled: !_vm.model.empty() && !_vm.model.card,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "card", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.view_flags & 0x04) !== 0
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8", md: "8" } },
                        [
                          _c("r-card-cluster-dropdown", {
                            attrs: {
                              model: _vm.model.cardCluster,
                              clearable: true,
                              disabled:
                                !_vm.model.empty() && !_vm.model.cardCluster,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "cardCluster",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.view_flags & 0x08) !== 0
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8", md: "8" } },
                        [
                          _c("r-card-package-dropdown", {
                            attrs: {
                              model: _vm.model.cardPackage,
                              clearable: true,
                              disabled:
                                !_vm.model.empty() && !_vm.model.cardPackage,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "cardPackage",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8", md: "8" } },
                    [
                      _c("r-currency-kind-dropdown", {
                        attrs: {
                          model: _vm.model.currencyKind,
                          clearable: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "currencyKind", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8", md: "8" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Amount: [ex: 2*D(6)+D(3) ]",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.amount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "amount",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Probability", "hide-details": "" },
                        model: {
                          value: _vm.model.percent,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "percent", _vm._n($$v))
                          },
                          expression: "model.percent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }